import { Button, Form, Modal, Space } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import IApplicationProperty from '~Api/Application/IApplicationProperty';
import { applicationPropertyValuationReceivedDateAction } from '~Applications/actions';
import DatePicker from '~UI/DatePicker';
import { IDictionary } from '~utilities/IDictionary';

interface IDefaultedValues {
    valuationReceivedDate: string;
}

interface IState {
    dirtyFields: IDictionary<boolean>;
    valuationReceivedDate: string;
}

interface IProps {
    applicationProperty: IApplicationProperty;
    isOpen: boolean;
    onCancel: () => void;
}

interface IPropsDispatch {
    updateValuationReceivedDate: (valuationReceivedDate: string) => void;
}

type Props = IProps & IPropsDispatch;

class ValuationReceivedDateModal extends React.Component<Props, IState> {
    public state: IState = {
        dirtyFields: {},
        valuationReceivedDate: null,
    };

    constructor(props: Props) {
        super(props);

        this.getDefaultedValues = this.getDefaultedValues.bind(this);

        this.onClickOk = this.onClickOk.bind(this);
        this.onClickClear = this.onClickClear.bind(this);
        this.onChangeValuationReceivedDate = this.onChangeValuationReceivedDate.bind(this);
    }

    public render(): JSX.Element {
        const { isOpen, onCancel } = this.props;
        const { valuationReceivedDate } = this.getDefaultedValues();

        const valuationReceivedDateDayJs: Dayjs = valuationReceivedDate ? dayjs(valuationReceivedDate) : null;

        return (
            <Modal
                okText='Update'
                onCancel={onCancel}
                onOk={this.onClickOk}
                open={isOpen}
                title='Valuation Received Date'
                wrapClassName='property-valuation-received-date-modal'
            >
                <Form.Item className='valuation-received-date' label='Received Date'>
                    <Space>
                        <DatePicker onChange={this.onChangeValuationReceivedDate} value={valuationReceivedDateDayJs} format='DD/MM/YYYY' />
                        <Button onClick={this.onClickClear}>Clear</Button>
                    </Space>
                </Form.Item>
            </Modal>
        );
    }

    private getDefaultedValues(): IDefaultedValues {
        const { applicationProperty } = this.props;
        const { dirtyFields, valuationReceivedDate } = this.state;

        return {
            valuationReceivedDate: dirtyFields.valuationReceivedDate ? valuationReceivedDate : applicationProperty.valuationReceivedDate,
        };
    }

    private onChangeValuationReceivedDate(date: Dayjs) {
        const { dirtyFields, valuationReceivedDate } = this.state;

        this.setState({
            dirtyFields: {
                ...dirtyFields,
                valuationReceivedDate: true,
            },
            valuationReceivedDate: dayjs(`${date.format('YYYY-MM-DD')} ${dayjs(valuationReceivedDate || undefined).format('HH:mm')}`).format(),
        });
    }

    private onClickClear() {
        const { dirtyFields } = this.state;

        this.setState({
            dirtyFields: {
                ...dirtyFields,
                valuationReceivedDate: true,
            },
            valuationReceivedDate: null,
        });
    }

    private onClickOk() {
        const { valuationReceivedDate } = this.getDefaultedValues();

        this.props.updateValuationReceivedDate(valuationReceivedDate);
        this.props.onCancel();
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: IProps): IPropsDispatch {
    return {
        updateValuationReceivedDate: (valuationReceivedDate: string) => dispatch(applicationPropertyValuationReceivedDateAction(ownProps.applicationProperty.uuid, valuationReceivedDate)),
    };
}

export default connect(
    null,
    mapDispatchToProps,
)(ValuationReceivedDateModal);
